import Base from "../base";


export default class SeccionServices extends Base {
  static endpointUrl = "encuestas/secciones/";
}